import type { ITTDCampaignAttributes } from './ttd_base';
import { TTDCampaign } from './ttd_base';
import type { CampaignClass } from './types';

export type TEmailListCampaign = ITTDCampaignAttributes & {
  readonly _cls: CampaignClass.EmailList;
  readonly email_mapping_type: 'uid2' | 'liveramp';
};

export class EmailListCampaign extends TTDCampaign<TEmailListCampaign> {}
